import { Model } from '@/model/Model'
import { BaseState } from '@stateMachine/BaseState'
import { IStateMachine } from '@stateMachine/IStateMachine'
import { BaseParentState } from './BaseParentState'

export class BaseChildState extends BaseState {
    protected readonly _parent: BaseParentState

    public constructor(parent: BaseParentState, stateMachine: IStateMachine, model: Model, id: string) {
        super(stateMachine, model, id)

        this._parent = parent
    }

    public canTrigger() {
        return true
    }

    public begin() {
        // empty
    }

    public end = () => {
        this._parent.endChild()
    }

    public cleanUp() {
        // empty
    }
}
